/**
 * 齐艳艳
 * 201707
 */

// import  china from 'echarts/map/js/china';
// import  world from 'echarts/map/js/world';
/**
 * 生成曲线图需要的数据 -- 一条线
 */
export const graphData = (__data, key, __D) => { //__data格式是array
    var __result = {
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: [{
                name: ''
            }]
        },
        title: {
            text: '',
            subtext: ''
        },

        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: []
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                formatter: '{value}',
                // rotate:'30'
            }
        },
        dataZoom: [{
            type: 'inside',
            start: 0,
            end: 100
        }, {
            start: 0,
            end: 10,
            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            handleSize: '80%',
            handleStyle: {
                color: '#fff',
                shadowBlur: 3,
                shadowColor: 'rgba(0, 0, 0, 0.6)',
                shadowOffsetX: 2,
                shadowOffsetY: 2
            }
        }],
        series: [{
            name: '',
            type: 'line',
            smooth: false,
            symbol: 'none',
            sampling: 'average',
            markLine: {},
            data: []
        }]
    }

    let avalibility = __D.title.text.indexOf('可用性') > -1 ? true : false;
    let flow = __D.title.text.indexOf('流畅') > -1 ? true : false;

    __result.title.text = __D.title.text || '标题';
    __result.title.subtext = __D.title.subtext || '样本量';
    __result.yAxis.axisLabel.formatter = __D.yAxis.axisLabel.formatter || '{value}';

    if (avalibility) {
        __result.series[0].markLine = { data: [{ label: { normal: { formatter: '{c}%' } }, lineStyle: { normal: { color: '#20A0FF' } }, yAxis: 95, name: '基准线' }] }
    } else if (flow) {
        __result.series[0].markLine = { data: [{ label: { normal: { formatter: '{c}%' } }, lineStyle: { normal: { color: '#20A0FF' } }, yAxis: 96, name: '基准线' }] }
    } else {
        if (__result.series[0].markLine || __result.series[0].markLine == "") {
            delete __result.series[0].markLine
        }
    }


    __result.legend.data[0].name = __D.legend.data[0].name || '样本量';
    __result.series[0].name = __D.legend.data[0].name || '样本量';
    __result.series[0].type = __D.series[0].type || 'line';


    let __type = [];
    let __dataArr = [];
    for (var value of __data) {
        __type.push(value[key]);
        __dataArr.push(value.dateTime || value.tm);
    }
    __result.series[0].data = __type;
    __result.xAxis.data = __dataArr;
    return __result;
};

// 渠道绘图
export const graphChannelData = (__data, key, __D) => { //__data格式是array
    var __result = {
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: [{
                name: ''
            }]
        },
        title: {
            text: '',
            subtext: ''
        },
        xAxis: {
            type: 'category',
            boundaryGap: true,
            data: []
        },
        yAxis: {
            type: 'value',
            boundaryGap: [0, '100%'],

            axisLabel: {
                formatter: '{value}'
            }
        },
        dataZoom: [{
            type: 'inside'
        }, {
            start: 0,
            end: 10,
            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            handleSize: '80%',
            handleStyle: {
                color: '#fff',
                shadowBlur: 3,
                shadowColor: 'rgba(0, 0, 0, 0.6)',
                shadowOffsetX: 2,
                shadowOffsetY: 2
            }
        }],
        series: [{
            name: '',
            type: 'bar',
            smooth: false,
            symbol: 'none',
            sampling: 'average',
            data: []
        }]
    }
    __result.title.text = __D.title.text || '标题';
    __result.title.subtext = __D.title.subtext || '样本量';
    __result.yAxis.axisLabel.formatter = __D.yAxis.axisLabel.formatter || '{value}';


    __result.legend.data[0].name = __D.legend.data[0].name || '样本量';
    __result.series[0].name = __D.legend.data[0].name || '样本量';
    __result.series[0].type = __D.series[0].type || 'line';
    //
    //
    //
    let __type = [];
    let __dataArr = [];
    for (var value of __data) {
        __type.push(value[key] * 100);
        __dataArr.push(value.channel)
    }
    __result.series[0].data = __type;
    __result.xAxis.data = __dataArr;
    return __result;
};
/**
 * 生成曲线图需要的数据 -- 多条线对比
 */
export const graphDataMultiple = (__data, keyArr, __D) => { //__data格式是array

    var __result = {
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: []
        },
        title: {
            text: '',
            subtext: ''
        },

        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: []
        },
        yAxis: {
            type: 'value',
            boundaryGap: [0, '100%'],
            max: 'dataMax',
            axisLabel: {
                formatter: '{value}'
            }
        },
        dataZoom: [{
            type: 'inside',
            start: 0,
            end: 100
        }, {
            start: 0,
            end: 10,
            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            handleSize: '80%',
            handleStyle: {
                color: '#fff',
                shadowBlur: 3,
                shadowColor: 'rgba(0, 0, 0, 0.6)',
                shadowOffsetX: 2,
                shadowOffsetY: 2
            }
        }],
        series: []
    }
    __result.title.text = __D.title.text || '标题';
    __result.title.subtext = __D.title.subtext || '样本量';

    // shaoyf
    for (var i = 0; i < keyArr.length; i++) {
        let __type = []; //key 对应的数值数组 例如uv对应的一系列数据
        let __dataArr = []; //x轴横坐标数值
        let seriesItem = {
            name: '',
            type: 'line',
            smooth: false,
            symbol: 'none',
            sampling: 'average',
            data: []
        }

        __result.legend.data[i] = __D.legend.data[i] || '样本量';
        seriesItem.name = __D.legend.data[i] || '样本量';
        __result.yAxis.axisLabel.formatter = __D.yAxis.axisLabel.formatter || '{value}';

        for (var value of __data) {
            __type.push(value[keyArr[i]]);
            __dataArr.push(value.dateTime || value.tm);
            seriesItem.data = __type;
        }

        __result.series.push(seriesItem)
        __result.xAxis.data = __dataArr;

    }
    return __result;
};

export const graphDataMultipleNew = (__data, key, __D) => { //__data格式是array
    let __result = {
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: []
        },
        title: {
            text: '',
            subtext: ''
        },

        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: []
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                formatter: '{value}'
            }
        },
        dataZoom: [{
            type: 'inside',
            start: 0,
            end: 100
        }, {
            start: 0,
            end: 10,
            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            handleSize: '80%',
            handleStyle: {
                color: '#fff',
                shadowBlur: 3,
                shadowColor: 'rgba(0, 0, 0, 0.6)',
                shadowOffsetX: 2,
                shadowOffsetY: 2
            }
        }],
        series: []
    }
    __result.title.text = __D.title.text || '标题';
    __result.title.subtext = __D.title.subtext || '样本量';
    __result.legend.data = __D.legend.data;
    let legend = __D.legend.data;
    let firstFlag = true;

    let __dataArr = []; //x轴横坐标数值

    for (let j in __data) {
        let seriesItem = {
            name: j,
            type: 'line',
            smooth: false,
            symbol: 'none',
            sampling: 'average',
            data: []
        };
        let dataItem = __data[j];
        for (let k = 0; k < dataItem.length; k++) {
            seriesItem.data.push(dataItem[k][key]);
            if (firstFlag) {
                __dataArr.push(dataItem[k].tm);
            }
        }
        firstFlag = false;
        __result.series.push(seriesItem);
    }

    __result.xAxis.data = __dataArr;

    return __result;
};


// 两个接口的数据 对比图 dataArr

export const graphDataM = (__dataM, key, __D) => { //__data格式是array
    var __result = {
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: []
        },
        title: {
            text: '',
            subtext: ''
        },

        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: []
        },
        yAxis: {
            type: 'value',
            max: 'dataMax',
            boundaryGap: [0, '100%'],
            axisLabel: {
                formatter: '{value}'
            }
        },
        dataZoom: [{
            type: 'inside',
            start: 0,
            end: 100
        }, {
            start: 0,
            end: 10,
            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            handleSize: '80%',
            handleStyle: {
                color: '#fff',
                shadowBlur: 3,
                shadowColor: 'rgba(0, 0, 0, 0.6)',
                shadowOffsetX: 2,
                shadowOffsetY: 2
            }
        }],
        series: []
    }
    __result.title.text = __D.title.text || '标题';
    __result.title.subtext = __D.title.subtext || '样本量';

    // shaoyf
    //
    for (var i = 0; i < __dataM.length; i++) {
        let __type = []; //key 对应的数值数组 例如uv对应的一系列数据
        let __dataArr = []; //x轴横坐标数值
        let seriesItem = {
            name: '',
            type: 'line',
            smooth: false,
            symbol: 'none',
            sampling: 'average',
            data: []
        };
        __result.legend.data[i] = __D.legend.data[i] || '样本量';
        seriesItem.name = __D.legend.data[i] || '样本量';
        __result.yAxis.axisLabel.formatter = __D.yAxis.axisLabel.formatter || '{value}';


        for (var value of __dataM[i]) {
            __type.push(value[key]);
            __dataArr.push(value.dateTime || value.tm);
            seriesItem.data = __type;
        }

        __result.series.push(seriesItem)
        __result.xAxis.data = __dataArr;

    }

    return __result;
};



// 点播页面 对比图 dataArr
export const graphDataMNew = (__dataM, key, __D) => { //__data格式是array
    var __result = {
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: []
        },
        title: {
            text: '',
            subtext: ''
        },

        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: []
        },
        yAxis: {
            type: 'value',
            max: 'dataMax',
            boundaryGap: [0, '100%'],
            axisLabel: {
                formatter: '{value}'
            }
        },
        dataZoom: [{
            type: 'inside',
            start: 0,
            end: 100
        }, {
            start: 0,
            end: 10,
            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            handleSize: '80%',
            handleStyle: {
                color: '#fff',
                shadowBlur: 3,
                shadowColor: 'rgba(0, 0, 0, 0.6)',
                shadowOffsetX: 2,
                shadowOffsetY: 2
            }
        }],
        series: []
    }
    __result.title.text = __D.title.text || '标题';
    __result.title.subtext = __D.title.subtext || '样本量';

    // shaoyf
    //
    for (var i = 0; i < __dataM.length; i++) {
        let __type = []; //key 对应的数值数组 例如uv对应的一系列数据
        let __dataArr = []; //x轴横坐标数值
        let seriesItem = {
            name: '',
            type: 'line',
            smooth: false,
            symbol: 'none',
            sampling: 'average',
            data: []
        };
        __result.legend.data[i] = __D.legend.data[i] || '样本量';
        seriesItem.name = __D.legend.data[i] || '样本量';
        __result.yAxis.axisLabel.formatter = __D.yAxis.axisLabel.formatter || '{value}';
        for (var value of __dataM[i]) {
            __type.push(value[key]);
            seriesItem.data = __type;
        }

        for (var value of __dataM[0]) { //两条线对比，横坐标取最新时间
            __dataArr.push(value.dateTime || value.tm);
        }
        __result.series.push(seriesItem);
        __result.xAxis.data = __dataArr;

    }

    return __result;
};


/**
 * 生成地域省内map需要的数据
 */
export const mapCityData = (__data, key, __D) => {
    var __result = {
        title: {
            text: '',
            left: 'left'
        },
        legend: {
            data: [{
                name: ''
            }]
        },
        tooltip: {},
        visualMap: {
            type: 'continuous',
            min: 50,
            max: 100,
            text: ['High', 'Low'],
            realtime: false,
            calculable: true,
            visualMap: true,
            itemGap: 0,
            itemSymbol: 'rect',
            color: ['#e0ffff', '#006edd']
        },
        series: [{
            name: '',
            type: 'map',
            map: 'china',
            data: []
        }]
    }

    let __type = [];
    for (var value of __data) {
        var obj = {};
        var __str = value.city.replace('省', '').replace('壮族自治区', '').replace('维吾尔自治区', '');
        obj.name = __str;
        obj.value = value[key]
        __type.push(obj);
    }
    __result.series[0].data = __type;
    __result.title.text = __D.title.text || '标题';

    __result.series[0].name = __D.legend.data[0].name;

    return __result;
}

/**
 * 生成地域国家map需要的数据
 */
export const mapNationData = (__data, key, __D) => {
    var __result = {
        title: {
            text: '',
            left: 'left'
        },
        legend: {
            data: [{
                name: ''
            }]
        },
        tooltip: {},
        visualMap: {
            type: 'continuous',
            min: 50,
            max: 100,
            text: ['High', 'Low'],
            realtime: false,
            calculable: true,
            visualMap: true,
            itemGap: 0,
            itemSymbol: 'rect',
            color: ['#e0ffff', '#006edd']
        },
        series: [{
            name: '',
            type: 'map',
            map: 'world',
            data: []
        }]
    }

    let __type = [];
    for (var value of __data) {
        var obj = {};
        var __str = value.city.replace('加拿大', 'Canada').replace('马来西亚', 'Malaysia').replace('美国', 'United States of America').replace('文莱', 'Brunei').replace('国内', 'China');
        obj.name = __str;
        obj.name = __str;
        obj.value = value[key];
        __type.push(obj);
    }
    __result.series[0].data = __type;
    __result.title.text = __D.title.text || '标题';

    __result.series[0].name = __D.legend.data[0].name;

    return __result;
}

/**
 * 生成地域map表格需要的数据
 */
export const mapTableData = (__data, key, __D) => {

    var _obj = {};
    var __obj = {};
    __obj.name = __D.title.name;
    __obj.value = __D.title.value;

    let __type = [];
    for (var value of __data) {
        var obj = {};
        var __str = value.city.replace('省', '').replace('壮族自治区', '').replace('维吾尔自治区', '').replace('国内', '中国');
        obj.name = __str;
        obj.value = value[key] + "%";
        __type.push(obj);
    }

    _obj.data = __type;
    _obj.head = __obj;
    return _obj;
}



/**
 * 生成地域柱状图需要的数据
 */
export const mapBarData = (__data, key, __D) => {
    var __result = {
        title: {
            text: '',
            subtext: ''
        },
        tooltip: {
            trigger: 'axis'
        },
        color: ['#FF8000'],
        grid: {
            left: '0%',
            right: '2%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: [{
            type: 'category',
            data: [],
            axisTick: {
                alignWithLabel: true
            }
        }],
        yAxis: [{
            type: 'value'
        }],
        series: [{
            name: '',
            type: 'bar',
            barWidth: '',
            data: []
        }]
    }

    __result.title.text = __D.title.text || '标题';
    __result.series[0].name = __D.title.text;

    let __type = [];
    let __dataArr = [];
    for (var value of __data) {
        __type.push(value[key]);
        __dataArr.push(value.city);
    }
    __result.series[0].data = __type;
    __result.xAxis[0].data = __dataArr;

    return __result;
};

export const loadScript = url => {
    let script = document.createElement('script');
    script.src = url;
    document.head.parentNode.insertBefore(script, document.head);
};


// WEBPACK FOOTER //
// ./utils/tools.js